/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import MenuItems from '../components/common/layout/menu/MenuItems';

export const isIE11 = !window['ActiveXObject'] && 'ActiveXObject' in window;

export const isPathnameFullTailView = (pathname: string) =>
  new RegExp(`^${MenuItems.fleet}/[(0-9)|(a-z)|(A-Z)|_]+`, 'g').test(pathname);

export const isPathnameFTVExport = (pathname: string) =>
  new RegExp(`^${MenuItems.fleet}/[(0-9)|(a-z)|(A-Z)]+/export`, 'g').test(pathname);
  
export const isPathnameFullSpaceVehicleView = (pathname: string) =>
  new RegExp(`^${MenuItems.transportMonitoring}/[(0-9)|(a-z)|(A-Z)|_]+`, 'g').test(pathname);
